(function () {
  /**
   * BatchGeo's polygon Drawing Manager tool. It allows you to click multiple
   * times on a map and create a polygon from those points.
   *
   * NOTE: The polygon tool has a lot of unique functionality so much of the
   * basetool is overwritten or slightly modified.
   */
  var BatchGeoDrawingManagerPolygon = $.extend(
    true,
    {},
    window.BatchGeoDrawingManagerBaseTool,
    {
      button: {
        class: "drawing-manager-button drawing-manager-button-polygon",
        title: "Measuring tool",
        order: 6,
        icon: "polygon",
        mode: "polygon",
      },

      /**
       * See BaseTool for docs on this method
       * @override
       */
      buildShape: function () {
        // If a shape exists then we're still drawing a polyline so don't build a
        // new shape
        if (this.shape) return this.shape;

        // Create an array to store the markers we place to show the user where
        // they clicked
        this._points = [];

        // Create an array that stores each LatLng which we use to add to our
        // polyline as the user clicks around the map
        this._path = [];

        var shape = new google.maps.Polyline(
          $.extend(
            {
              map: this.drawingManager.settings.map,
              path: this._path,
              editable: false,
              draggable: false,
              strokeColor: "#4285F4",
              strokeWeight: 5,
              zIndex: 999,
            },
            this.options,
          ),
        );

        // .getBounds is a method on all other shapes in Google Maps but not on
        // Polyline tools. It was in API v2, but not v3. This is a custom
        // getBounds method that should act the same as the native getBounds
        shape.getBounds = function () {
          var bounds = new google.maps.LatLngBounds();
          this.getPath().forEach(function (item) {
            bounds.extend(new google.maps.LatLng(item.lat(), item.lng()));
          });
          return bounds;
        };

        return shape;
      },

      /**
       * See BaseTool for docs on this method
       * @override
       */
      resizeShapeHandler: function (event) {
        if (event.button !== 1) {
          var drawingManager = this.drawingManager;
          var point = drawingManager.fromEventToLatLng(event);

          this.makePoint(point);
          this._path.push(point);

          // After we've pushed the new LatLng the user created by clicking we
          // update the shape path with the new array which includes the new LatLng.
          this.shape.setOptions({ path: this._path });
        }
      },

      /**
       * See BaseTool for docs on this method
       * @override
       */
      enable: function (drawingManager, options) {
        var self = this;
        this.options = options;
        this.drawingManager = drawingManager;
        this.prevShapes = [];

        $(document.body).addClass(
          "drawing-manager-is-selecting drawing-manager-is-selecting-" +
            drawingManager.getDrawingMode(),
        );

        // Handle the mouse up which tracks if the user has the shift and/or the
        // control/command key pressed. We don't do an anonymous functions so that
        // we can unbind it later.
        this._onMouseUp = function (event) {
          self._isShiftDown = event.shiftKey;
          self._isCtrlDown = event.metaKey || event.ctrlKey;
        };

        // We wrap these events multiple times so that we can have the right
        // "this" context like if we did bind() or call() but be able to actually
        // unbind these events later in disable.
        this._onDrawStart = function (jqEvent, event) {
          self.drawStartHandler(event);
        };
        this._onDrawChange = function (jqEvent, event) {
          self.drawChangeHandler(event);
        };
        this._onClearMap = function () {
          self.prevShapes.forEach((shape) => {
            shape.setMap(null);
          });

          self.prevShapes = [];
          self.removeShape();
          self.removeLabel();
        };
        // Hanldes double clicks which with the polygon tool will automatically
        // close and end it by making a line directly to the starting position.
        this._onDblClick = function (event) {
          if (!self._path || !self.shape) return;
          if (!self.isSelectableArea(event)) return;
          self._path.push(self._path[0]);
          self.shape.setOptions({ path: self._path });
          self.drawEndHandler();
        };

        $(window).on("mouseup", this._onMouseUp);
        $(window).on("dblclick", this._onDblClick);
        $(window).on("batchgeo.drawingmanager.start", this._onDrawStart);
        $(window).on("batchgeo.drawingmanager.end", this._onDrawChange);
        $(window).on("batchgeo.drawingmanager.clearMap", this._onClearMap);
      },

      /**
       * See BaseTool for docs on this method
       * @override
       */
      disable: function () {
        $(document.body).removeClass(
          "drawing-manager-is-selecting drawing-manager-is-selecting-" +
            this.drawingManager.getDrawingMode(),
        );
        $(window).off("mouseup", this._onMouseUp);
        $(window).off("dblclick", this._onDblClick);
        $(window).off("batchgeo.drawingmanager.start", this._onDrawStart);
        $(window).off("batchgeo.drawingmanager.end", this._onDrawEnd);
        $(window).off("batchgeo.drawingmanager.clearMap", this._onClearMap);
        this.drawingManager.disableMapPanning();
        this.clearPolygon();
        if (this.prevShapes.length) {
          this.prevShapes.forEach((shape) => {
            shape.setMap(null);
            // TODO(tom) I don't think this does anything it just deletes the local copy
            // of the var in this function. But I'm not sure. It's breaking eslint parse
            // delete shape;
          });
        }
      },

      /**
       * Creates a polygon "point" used for user feedback to let them know where
       * they clicked. It also sets up a listener on the first point created that
       * closes the polygon and calls the draw end handler.
       *
       * @param {object} location Google LatLng object to be used as the location
       * @return {undefined}
       */
      makePoint: function (location) {
        var self = this;

        // Store the points (Markers) in the array on the proto so we can remove
        // them all from the map once the selection is done.
        // We use custom Markers instead of drawing shapes because they are always
        // the same size at any zoom level. Circle shapes are based in meters.
        this._points.push(
          new google.maps.Marker({
            position: location,
            map: self.drawingManager.settings.map,
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 9.5,
              fillColor: "#4285F4",
              strokeColor: "#4285F4",
              fillOpacity: 0.4,
              strokeWeight: 0.4,
            },
          }),
        );

        // If it's the first point created...
        if (this._points.length === 1) {
          // We add a click event to it that calls the drawEndHandler. We do this
          // on the first marker because it makes a fully closed shape.
          google.maps.event.addListener(this._points[0], "click", function () {
            self.drawEndHandler();
          });
        }
      },

      /**
       * Handles what happens when a selection is complete on mouseup which is
       * mainly finding which markers were in the selection. It finally sends off
       * a select event with the selected markers.
       *
       * This overrides the default selectionHandler because polygons need to use
       * a special function from the Google Maps API to check if markers are
       * inside. If you use the normal way (extending bounds) it turns the bounds
       * it will select nearby markers since it extends out in a non-polygon.
       *
       * @override
       * @param  {object} selection A Google Maps Rectangle object
       * @return {undefined}
       */
      selectionHandler: function (selection) {
        this.processSelection((item) => {
          return google.maps.geometry.poly.containsLocation(
            item.getPosition(),
            selection,
          );
        });
      },

      /**
       * Returns all points of the polygon
       * @return {Array} An array of google Markers
       */
      getPoints: function () {
        return this._points;
      },

      /**
       * Returns true if the area clicked on is a "valid" area to click. The whole
       * map wrapper is selectable but the coords provided.
       *
       * The only current invalid space is the zoom in/out and streetview buttons
       *
       * @param {object} event A DOM/jQuery event object
       * @return {boolean} A boolean if it's in a safe zone or not
       */
      isSelectableArea: function (event) {
        var offset = this.drawingManager.getEventOffsets(event);
        return offset.x > 45 || offset.y > 105;
      },

      /**
       * Clears all the drawings on the map that create the polygon such as the
       * Polyline instance as well as the point markers.
       *
       * @return {undefined}
       */
      clearPolygon: function () {
        // There is no shape if you aren't drawing a polygon so just return early
        if (!this.shape) return;

        this.shape.setMap(null);

        // Remove the shape object since next time we want to start fresh
        delete this.shape;

        // For every point in the point array we set the map to null which deletes
        // it from the map
        this._points.forEach(function (point) {
          point.setMap(null);
        });
      },

      /**
       * See BaseTool for docs on this method
       * @override
       */
      drawStartHandler: function (event) {
        if (!event.shiftKey) {
          if (this.prevShapes.length) {
            this.prevShapes.forEach((shape) => {
              shape.setMap(null);
            });
          }

          this.prevShapes = [];
        }

        if (!this.isSelectableArea(event)) return;
        this.shape = this.buildShape();
        this.drawingManager.clearMap();
        this.drawingManager.enableMapPanning();
        BatchGeoStore.dispatch({
          type: "DRAWING_MANAGER_SELECTION_STATUS",
          status: true,
        });
      },

      /**
       * See BaseTool for docs on this method
       * @override
       */
      drawChangeHandler: function (event) {
        if (!this.isSelectableArea(event)) return;
        this.resizeShapeHandler(event);
      },

      /**
       * See BaseTool for docs on this method
       * @override
       */
      drawEndHandler: function () {
        this.drawingManager.disableMapPanning();
        this.selectionHandler(this.shape);
        this.prevShapes = [
          ...this.prevShapes,
          new google.maps.Polygon({
            ...this.drawingManager.settings.shapeOptions,
            map: this.drawingManager.settings.map,
            paths: this._points.map(
              (point) =>
                new google.maps.LatLng(
                  point.position.lat(),
                  point.position.lng(),
                ),
            ),
          }),
        ];

        this.clearPolygon();
        BatchGeoStore.dispatch({
          type: "DRAWING_MANAGER_SELECTION_STATUS",
          status: false,
        });
      },

      /**
       * See BaseTool for docs on this property
       * @override
       */
      draggable: false,
    },
  );

  window.BatchGeoDrawingManagerPolygon = BatchGeoDrawingManagerPolygon;
})(window);
